<div
  class="absolute inset-0 flex h-full min-h-fit justify-center bg-gray-100 p-6">
  <div
    class="h-fit w-full rounded-lg border border-gray-200 bg-white p-6 lg:w-8/12">
    <ng-content />
  </div>
</div>
